import React from 'react'
import { array, bool } from 'prop-types'
import intl from 'react-intl-universal'

import Select from 'react-select'
import { branch } from 'baobab-react/higher-order'
import API from 'utils/API'
import buildUrl from 'utils/buildUrl'
import storage from 'utils/storage'

import BaseTemplate from 'components/templates/BaseTemplate'
import Col from 'components/atoms/Col'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Typography from 'components/atoms/Typography'
import Thumbnails from 'components/organisms/Thumbnails'

class Scholarships extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      query: {
        page: 1,
        per_page: 12,
        provider: '',
        purpose: '',
      },
      loading: false,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { query } = this.state
    if (prevState.query !== query) {
      this.fetchScholarships()
    }
  }

  fetchScholarships = () => {
    this.setLoading(true)
    setTimeout(() => {
      API.get('/scholarships.json', this.state.query)
      .then(({ data }) => {
        const serverProps = storage.select('serverProps')
        const updatedData = {
          page: data.params.page,
          perPage: data.params.perPage,
          isLastPage: data.isLastPage,
          scholarships: data.params.page > 1 ?
            [...this.props.scholarships, ...data.scholarships] :
            [...data.scholarships],
        }
        serverProps.merge(updatedData)
        this.setLoading(false)
      })
      .catch(() => {
        this.setLoading(false)
      })
    }, 500)
  }

  loadMore = () => {
    const { query } = this.state
    this.setQuery({
      ...query,
      page: query.page + 1,
    })
  }

  setQuery = (val) => {
    this.setState({ query: val })
  }

  setLoading = (val) => {
    this.setState({ loading: val })
  }

  updateQuery = (newQuery) => {
    this.setQuery({ ...this.state.query, ...newQuery })
  }

  setBuildUrl = (val) => {
    buildUrl({
      path: 'scholarships',
      queryParams: val,
    })
  }

  handleFilterProviderChange = (e) => {
    if (e) {
      this.updateQuery({ provider: e.value, page: 1 })
      const { purpose } = this.state.query
      const filter = purpose ? { provider: e.value, purpose } : { provider: e.value }
      this.setBuildUrl(filter)
    } else {
      this.updateQuery({ provider: '', page: 1 })
    }
  }

  handleFilterPurposeChange = (e) => {
    if (e) {
      this.updateQuery({ purpose: e.value, page: 1 })
      const { provider } = this.state.query
      const filter = provider ? { provider, purpose: e.value } : { purpose: e.value }
      this.setBuildUrl(filter)
    } else {
      this.updateQuery({ purpose: '', page: 1 })
    }
  }

  render() {
    const { isLastPage, scholarships } = this.props
    const { loading, query } = this.state

    const filterProviderOptions = [
      {
        value: 'government',
        label: 'Pemerintah',
      },
      {
        value: 'campus',
        label: 'Kampus',
      },
      {
        value: 'private',
        label: 'Swasta/Organisasi',
      },
      {
        value: 'international',
        label: 'Internasional',
      },
    ]

    const filterPurposeOptions = [
      {
        value: 'overseas',
        label: 'Luar Negeri',
      },
      {
        value: 'domestic',
        label: 'Dalam Negeri',
      },
    ]

    return (
      <BaseTemplate useNewHeader>
        <div className="scholarships-page">
          <div className="scholarships-page__heading">
            <Container>
              <Typography component="h1" variant="headline">
                {intl.get('containers.Scholarships.directory')}
              </Typography>
              <div className="scholarships-page__filters">
                <Typography component="h6" variant="body" className="scholarships-page__filter-title">
                  Filter
                </Typography>
                <Row>
                  <Col md="4">
                    <Select
                      className="scholarships-page__filter-opts"
                      classNamePrefix="scholarship-sort-opts"
                      placeholder={intl.get('containers.Scholarships.filter_by_provider')}
                      options={filterProviderOptions}
                      onChange={this.handleFilterProviderChange}
                      isClearable
                    />
                  </Col>
                  <Col md="4">
                    <Select
                      className="scholarships-page__filter-opts"
                      classNamePrefix="scholarship-sort-opts"
                      placeholder={intl.get('containers.Scholarships.filter_by_purpose')}
                      options={filterPurposeOptions}
                      onChange={this.handleFilterPurposeChange}
                      isClearable
                    />
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </div>
        <Container>
          <div className="scholarships-page__list">
            {
              ((query.page === 1 && !loading) || (query.page > 1)) &&
                <Thumbnails
                  kind="scholarships-directory"
                  data={scholarships}
                  isLoading={loading}
                  isLastPage={isLastPage}
                  isLikeable
                  loadMoreText={intl.get('containers.Scholarships.see_other_scholarships')}
                  loadMoreFunction={this.loadMore}
                  openNewTab
                  noBackground
                />
            }
          </div>
        </Container>
        <style jsx>
          {`
            .scholarships-page {
              &__heading {
                padding: 16px 0 24px;
                background-color: #ebeef3;
              }
              &__filters {
                margin-top: 16px;
              }
              &__list {
                margin-bottom: 32px;
                :global(.cmps-row) {
                  margin-bottom: 16px;
                }
              }
              :global(&__filter-title) {
                margin-bottom: 5px !important;
                color: #7d92a9 !important;
              }
              :global(&__filter-opts) {
                @media screen and (max-width: 767px) {
                  margin-bottom: 10px;
                }
              }
              :global(.scholarship-sort-opts__menu) {
                z-index: 2;
              }
            }
          `}
        </style>
      </BaseTemplate>
    )
  }
}


Scholarships.propTypes = {
  scholarships: array,
  isLastPage: bool,
}

Scholarships.defaultProps = {
  scholarships: [],
}

export { Scholarships }
export default branch({
  scholarships: ['serverProps', 'scholarships'],
  isLastPage: ['serverProps', 'isLastPage'],
  page: ['serverProps', 'page'],
  perPage: ['serverProps', 'perPage'],
}, Scholarships)
